import React from 'react';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import SelectField from 'Parts/ui/components/fields/SelectField';

//import './CampaignCreationBehaviorField.less';

import CampaignCreationBehaviorField_en from './locales/CampaignCreationBehaviorField_en.json';
import CampaignCreationBehaviorField_fr from './locales/CampaignCreationBehaviorField_fr.json';

i18next.addResourceBundle('en', 'CampaignCreationBehaviorField', CampaignCreationBehaviorField_en);
i18next.addResourceBundle('fr', 'CampaignCreationBehaviorField', CampaignCreationBehaviorField_fr);

function CampaignCreationBehaviorField({ t, form, initialValue }) {
  return (
    <>
      <SelectField
        form={form}
        fieldId="campaign_behavior"
        label={t('tickets-label')}
        optionsArray={[
          { value: 0, text: t('No') }, // Default
          { value: 1, text: t('Yes') } // Event
        ]}
        initialValue={initialValue || 0}
        colon={false}
      />
    </>
  );
}

export default translate('CampaignCreationBehaviorField')(CampaignCreationBehaviorField);
